import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Shader } from '../shader/Shader.mjs';
import { Program } from '../shader/Program.mjs';
import { UniformGroup } from '../shader/UniformGroup.mjs';
import { Matrix } from '@pixi/math';
var BatchShaderGenerator = /*#__PURE__*/function () {
  function BatchShaderGenerator(vertexSrc, fragTemplate) {
    _classCallCheck(this, BatchShaderGenerator);
    this.vertexSrc = vertexSrc;
    this.fragTemplate = fragTemplate;
    this.programCache = {};
    this.defaultGroupCache = {};
    if (!fragTemplate.includes("%count%")) {
      throw new Error('Fragment template must contain "%count%".');
    }
    if (!fragTemplate.includes("%forloop%")) {
      throw new Error('Fragment template must contain "%forloop%".');
    }
  }
  _createClass(BatchShaderGenerator, [{
    key: "generateShader",
    value: function generateShader(maxTextures) {
      if (!this.programCache[maxTextures]) {
        var sampleValues = new Int32Array(maxTextures);
        for (var i = 0; i < maxTextures; i++) {
          sampleValues[i] = i;
        }
        this.defaultGroupCache[maxTextures] = UniformGroup.from({
          uSamplers: sampleValues
        }, true);
        var fragmentSrc = this.fragTemplate;
        fragmentSrc = fragmentSrc.replace(/%count%/gi, "".concat(maxTextures));
        fragmentSrc = fragmentSrc.replace(/%forloop%/gi, this.generateSampleSrc(maxTextures));
        this.programCache[maxTextures] = new Program(this.vertexSrc, fragmentSrc);
      }
      var uniforms = {
        tint: new Float32Array([1, 1, 1, 1]),
        translationMatrix: new Matrix(),
        default: this.defaultGroupCache[maxTextures]
      };
      return new Shader(this.programCache[maxTextures], uniforms);
    }
  }, {
    key: "generateSampleSrc",
    value: function generateSampleSrc(maxTextures) {
      var src = "";
      src += "\n";
      src += "\n";
      for (var i = 0; i < maxTextures; i++) {
        if (i > 0) {
          src += "\nelse ";
        }
        if (i < maxTextures - 1) {
          src += "if(vTextureId < ".concat(i, ".5)");
        }
        src += "\n{";
        src += "\n\tcolor = texture2D(uSamplers[".concat(i, "], vTextureCoord);");
        src += "\n}";
      }
      src += "\n";
      src += "\n";
      return src;
    }
  }]);
  return BatchShaderGenerator;
}();
export { BatchShaderGenerator };